import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { URL } from "./apiurl";

export const handleSyncTest = createAsyncThunk("synctest", async (payload) => {
  console.log(payload)
  const response = await axios.post(
    URL.GETINVESTIGATION,
    {
      DataType: payload?.searchBy,
      CompanyId: window?.localStorage?.getItem("CompanyID"),
      PanelID: payload?.PanelID,
      TestName:"",
      TestCode:"",
    }
  );
  return response.data;
});

const initialState = {
  error: false,
  loading: false,
  success: false,
  test: [],
};

export const getSyncAlTest = createSlice({
  name: "test",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(handleSyncTest.pending, (state, action) => {
        state.loading = true;
        state.test = [];
      })
      .addCase(handleSyncTest.fulfilled, (state, action) => {
        state.loading = false;
        state.test = action?.payload ? action?.payload.message : state.test;
      })
      .addCase(handleSyncTest.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// this is for dispatch
export const { test } = getSyncAlTest.actions;

// this is for configureStore
export default getSyncAlTest.reducer;
